import Moment from 'moment-timezone';
import React, { PureComponent } from 'react';
import { CSVLink } from 'react-csv';
import { Button, Cell, Grid, SelectField } from 'react-md';
import { NotificationManager } from 'react-notifications';
import { BeatLoader } from 'react-spinners';
import ApiRequestService from '../component/ApiRequestService';
import CategoryDropDown from '../component/CategoryDropDown';
import CourseDropDown from '../component/CourseDropDown';
import LoadingSpinner from '../component/LoadingSpinner';
import Properties from '../component/Properties';
import SectionDropDown from '../component/SectionDropDown';
import SecureShow from '../component/SecureShow';
import { AppProperties } from '../common/function';
//CSS Imports
import '../css/Dashboard.css';
import '../css/gradeBook.css';






//let appProperties = new Properties();


const loaderColor = '#bb0000';


export default class PerfData extends PureComponent {

    appProperties = new AppProperties();

    
    constructor(props) {
        super(props);
        this.state = {
            selectedCourseID: 0,
            selectedSectionIDs: [],
            selectedCategoryIDs: [],
            showDialog: false,
            selectedSectionIDsForCategory: [],
            selectedFetchDataCatIds:[],
            showCourse: true,
            courses: undefined,
            perfData:null,
            perfNonGradedData:null,
            questionColumn:[],
            perfDataLoading : false,
            showSection: false,
            showCategoryButton: false,
            showCategory: false,
            showNonGradedCategory: false,
            showFetchDataButton: false,
            showNonGradedFetchDataButton: false,
            showCsvDownloadButton: false,
            showCsvDownloadButtonLoader :false,
        };



    }


    monitorWindowSize = () => {
        window.addEventListener("resize", this.setgridHeight);
    }

    componentWillMount() {
        if(!this.props.archiveMode){
            this.setState({
                showCourse:false
            })
        }
        this.monitorWindowSize();
    }

    componentWillUnmount() {
        window.removeEventListener("resize", this.setgridHeight);
    }

    getPerfData =  (selectedCourseId, selectedSectionId, selectedCategoryId) => {
        const payload = {
            course_id: selectedCourseId,
            section_id: selectedSectionId,
            category_id: selectedCategoryId
        };


        ApiRequestService({
            method: 'post',
            url: '/getPerfData',
            data: payload
        }).then(res => {
            console.debug("response ",res)
            if (
                res.data.data !== null &&
                res.data.data !== undefined
            ) {
                this.setState({
                    perfData: res.data.data,
                    showCsvDownloadButtonLoader:false
                    
                })
            } else {
                NotificationManager.error("Error - Performance-Data is Empty in Selected Categroy. Please Select a different Category.");
                this.setState({
                    showCsvDownloadButton: false,
                    showFetchDataButton :true,
                    showNonGradedFetchDataButton: false,
                    showCsvDownloadButtonLoader:false
                })
            }
        }).catch(error => {
            console.error('Error When Retriving Performance Details ', error);
        });

    }

    getPerfNonGradedData =  (selectedCourseId, selectedSectionId, selectedCategoryId) => {
        const payload = {
            course_id: selectedCourseId,
            section_id: selectedSectionId,
            category_id: selectedCategoryId
        };


        ApiRequestService({
            method: 'post',
            url: '/getPerfNonGradedData',
            data: payload
        }).then(res => {
            console.debug("response ",res)
            if (
                res.data.data !== null &&
                res.data.data !== undefined
            ) {
                this.setState({
                    perfNonGradedData: res.data.data.perf_data,
                    questionColumn: res.data.data.questions_column,
                    showCsvDownloadButtonLoader:false
                    
                })
            } else {
                NotificationManager.error("Error - Performance-Data is Empty in Selected Categroy. Please Select a different Category.");
                this.setState({
                    showCsvDownloadButton: false,
                    showFetchDataButton :false,
                    showNonGradedFetchDataButton: true,
                    showCsvDownloadButtonLoader:false
                })
            }
        }).catch(error => {
            console.error('Error When Retriving Performance Details ', error);
        });

    }


    onSemesterChange = (semester) => {
        console.debug("selected sem id ",semester)
        this.setState({
            selectedSemesterID:semester.id,
            selectedCourseID: undefined,
            selectedSectionIDs: [],
            selectedSectionIDsForCategory: [],
            selectedCategoryIDs: [],
            columnsForQuiz: [],
            showSection:false,
            showCategoryButton:false,
            showCourse:true,
            isSemesterLoading:true,
            showCategory:false,
            showNonGradedCategory:false,
            showFetchDataButton :false,
            showNonGradedFetchDataButton: false,
            showCsvDownloadButton:false,
            showCsvDownloadButtonLoader:false

        });        
      //  this.getCategoryByCourseID(course.course_id);
        this.getAllCoursesForSemester(semester.id)
    }

    
    getAllCoursesForSemester = (semId) =>{
        console.debug("in getAllCoursesForSemester")
        var payload = {
            id : semId
        }
        ApiRequestService({
                url:'/getAllCoursesForSemester',
                method:'post',
                data:payload
              }).then(res => {
                if(res.data !== undefined && res.data !== null &&
                    res.data.data !== undefined && res.data.data !== null){
                    if(res.data.status === 0){
                        let courseArray = res.data.data.course_names.map(
                            this.makeCourselistArray
                          );
                        this.setState({
                            courses:courseArray,
                            showCourse:false,
                            isSemesterLoading:false
                        });
                         console.debug("in getAllCoursesForSemester",res.data)                         
                        }else{
                            NotificationManager.error("error",res.data.message,5000);
                        }
                    }else{
                        NotificationManager.error("No Courses");
                    }
            }).catch(error => {
                NotificationManager.error("Get courses Failed  : "+error,"ERROR",2000)
            });
    }

    getUserSectionForCourses =  (courseId) => {
        ApiRequestService({
            url:'/getUserSectionForCourses',
            method:'post',
            data:{
                    course_id : courseId
                }
            }).then(response => {
            if(response && response.data){
                if(response.data.status === 0){
                    if(response.data.data !== null && response.data.data !== undefined &&response.data.data[0] !== null){
                        //(response.data.data).unshift({section_name: "All Sections"})                                                
                        this.setState({
                            sectionMap:response.data.data,
                            showSection:true,
                            selectedCourseID: courseId,
                            selectedSectionIDs: [],
                            selectedSectionIDsForCategory: [],
                            selectedCategoryIDs: [],
                            columnsForQuiz: [],
                            loadingCourse:false,
                        });
                        //this.getCategoryByCourseID(response.data.data[0].course_id);
                    }else{
                        NotificationManager.error("No Section in selected Course",response.data.message,5000);                                              
                        this.setState({
                            sectionMap:[],
                            showSection:false,
                            selectedCourseID: courseId,
                            selectedSectionIDs: [],
                            selectedSectionIDsForCategory: [],
                            selectedCategoryIDs: [],
                            columnsForQuiz: [],
                            loadingCourse:false,
                        });
                    }
                }else{
                    NotificationManager.error("error",response.data.message,5000);
                }
            }else{
                NotificationManager.error("error","Error - Empty Response",5000);
            }

        }).catch(error => {
            NotificationManager.error("Get Graph Failed : "+error,"ERROR",2000)
        }); 
    }
     
    makeCourselistArray(courseObject, index) {
        return {
            key: 'KEY_' + index,
            title: courseObject.course_name,
            value: courseObject.course_id
        };
    }
    //On    Course Selected
    onCourseChange = (argSelectedCourseID) => {
        this.setState({
            showCategoryButton:false,
            loadingCourse:true,
            showSection:false,
            selectedSectionIDs: [],
            selectedSectionIDsForCategory: [],
            selectedCategoryIDs: [],
            columnsForQuiz: [],
                showCategory:false,
                showNonGradedCategory:false,
                showFetchDataButton :false,
                showNonGradedFetchDataButton: false,
                showCsvDownloadButton:false,
                showCsvDownloadButtonLoader:false
        })
        console.debug("selected course id ",argSelectedCourseID)
        if(this.props.archiveMode){
            this.getUserSectionForCourses(argSelectedCourseID)
        }else{
            this.setState({
            showSection:true,
            selectedCourseID: argSelectedCourseID,
            loadingCourse:false,
            })
        }
    };

    
    //On Section Selected
    onSectionChange = (argSelectedSectionIDs) => {
        let sectionIds = []
        argSelectedSectionIDs.forEach(row => {
            if(row.value && row.id !== 'enableAll' && row.id !== 'enableNone'){
                sectionIds.push(row.id);
            }  
        })
                
        if(sectionIds.length>0){
            this.setState({
                showCategoryButton:true,
                showCategory:false,
                showNonGradedCategory:false,
                showFetchDataButton :false,
                showNonGradedFetchDataButton: false,
                showCsvDownloadButton:false,
                showCsvDownloadButtonLoader:false
            });
        }else{
            this.setState({
                showCategoryButton:false,
                showCategory:false,
                showNonGradedCategory:false,
                showFetchDataButton :false,
                showNonGradedFetchDataButton: false,
                showCsvDownloadButton:false,
                showCsvDownloadButtonLoader:false
            });
        }
        this.setState({
            selectedSectionIDs: argSelectedSectionIDs,
            selectedSectionIDsForCategory: sectionIds,
        });
        console.debug("selected section ", argSelectedSectionIDs, sectionIds)
    };

    //On Category Selected
    onCategoryChange = (argSelectedCategoryIDs) => {
        let catIds = []
        console.debug("selectwed data : ",argSelectedCategoryIDs)
        argSelectedCategoryIDs.forEach(row => {
            if(row.value && row.id !== 'enableAll' && row.id !== 'enableNone'){
                catIds.push(row.subjectId+"_"+row.topicId+"_"+row.index);
            }
        })
        if(catIds.length>0){
            this.setState({
                showFetchDataButton:true,
                showNonGradedFetchDataButton: false,
                showCsvDownloadButton: false,
                showCsvDownloadButtonLoader:false
            });
        }else{
            this.setState({
                showFetchDataButton:false,
                showNonGradedFetchDataButton: false,
                showCsvDownloadButton: false,
                showCsvDownloadButtonLoader:false
            });
        }
        this.setState({
            selectedCategoryIDs: argSelectedCategoryIDs,
            selectedFetchDataCatIds: catIds
        });
        console.debug("selwcted Category ", argSelectedCategoryIDs, catIds)
    };

    //On Non-Graded Category Selected
    onNonGradedCategoryChange = (argSelectedCategoryIDs) => {
        let catIds = []
        console.debug("selectwed data : ",argSelectedCategoryIDs)
        argSelectedCategoryIDs.forEach(row => {
            if(row.value && row.id !== 'enableAll' && row.id !== 'enableNone'){
                catIds.push(row.subjectId+"_"+row.topicId+"_"+row.index);
            }
        })
        if(catIds.length>0){
            this.setState({
                showFetchDataButton:false,
                showNonGradedFetchDataButton: true,
                showCsvDownloadButton: false,
                showCsvDownloadButtonLoader:false
            });
        }else{
            this.setState({
                showFetchDataButton:false,
                showNonGradedFetchDataButton: false,
                showCsvDownloadButton: false,
                showCsvDownloadButtonLoader:false
            });
        }
        this.setState({
            selectedCategoryIDs: argSelectedCategoryIDs,
            selectedFetchDataCatIds: catIds
        });
        console.debug("selected Non-Graded Category ", argSelectedCategoryIDs, catIds)
    };

    categroyEmptyData = () =>{
        this.setState({
            showCategory: false,
            showCategoryButton:true
        });
    }

    showCategoryButtonOnClick = () =>{
        this.setState({
            categoryLoading:true,
            showCategory: true,
            showCategoryButton:false
        });
    }
    showCategoryNonGradedButtonOnClick = () =>{
        this.setState({
            categoryLoading:true,
            showNonGradedCategory: true,
            showCategoryButton:false
        });
    }
    fetchDataButtonOnClick = () =>{
        
        
        this.setState({
            showCsvDownloadButton: true,
            showFetchDataButton :false,
            showNonGradedFetchDataButton: false,
            showCsvDownloadButtonLoader:true
        });
        this.getPerfData(this.state.selectedCourseID, this.state.selectedSectionIDsForCategory, this.state.selectedFetchDataCatIds)

    }

    fetchNonGradedDataButtonOnClick = () =>{
        
        
        this.setState({
            showCsvDownloadButton: true,
            showFetchDataButton :false,
            showNonGradedFetchDataButton: false,
            showCsvDownloadButtonLoader:true
        });
        this.getPerfNonGradedData(this.state.selectedCourseID, this.state.selectedSectionIDsForCategory, this.state.selectedFetchDataCatIds)

    }

    render() {
        let downloadCSV = null

        if (this.state.perfNonGradedData !== undefined && this.state.perfNonGradedData !== null){

            let tempColumn= [];
               this.state.questionColumn.map((header, index) => {
                let htmlRmHeader = header.replace(/<[^>]+>/g,'')
                    let tempRow = {};
                    tempRow["label"] = htmlRmHeader;
                    tempRow["key"] = htmlRmHeader;
                    tempColumn.push(tempRow);
                })
           
            let FinalArray =  this.state.perfNonGradedData
            FinalArray.map((column) =>{
             column.nongraded_questionname.map((key, index) =>{
                column[key.replace(/<[^>]+>/g, '')] = column.nongraded_answertext[index].replace(/<[^>]+>/g, '');
            });
            })


            var headers = [
                { label: 'ID', key: 'osu_id' },
                { label: 'Student ID', key: 'user_id' },
                { label: 'Section Name', key: 'section_name' },
                { label: 'Subection Name', key: 'subsection_name' },
                { label: 'Assignment Name', key: 'quiz_name' },
                { label: 'Mastery Count', key: 'mastery_count' },
                { label: 'Categroy Name', key: 'category_name' },
                { label: 'Categroy Start Date', key: 'category_start_time' },
                { label: 'Category Completed Date', key: 'category_completed_time' },
            ];
            tempColumn.map((row)=>{
                headers.push(row);
            })

            let csvPerfData = FinalArray
            let currentTime = Moment.tz(Date(), this.appProperties.currentUserData.timeZone || "America/New_York");
            
            downloadCSV = (
                <div>
                    <CSVLink
                        data={csvPerfData}
                        headers={headers}
                        filename={'Performance Data' +
                            '_' +
                            currentTime.format() +
                            '.csv'
                        }
                    >
                        {
                        <Button style={{ marginTop: "15px" }} flat primary iconChildren="cloud_download" >Download CSV</Button>
                        }
                    </CSVLink>
                </div>
            );

        }

        if (this.state.perfData !== undefined && this.state.perfData !== null ) {

            // {categoryNamesArr.map((categoryName) =>
            //   label: categoryName, key:  )}


            var headers = [
                { label: 'ID', key: 'osu_id' },
                { label: 'Student ID', key: 'user_id' },
                { label: 'Section Name', key: 'section_name' },
                { label: 'Subsection Name', key: 'subsection_name' },
                { label: 'Assignment Name', key: 'quiz_name' },
                { label: 'Mastery Count', key: 'mastery_count' },
                { label: 'Categroy Name', key: 'category_name' },
                { label: 'Categroy Start Date', key: 'category_start_time' },
                { label: 'Category Completed Date', key: 'category_completed_time' },
                { label: 'Categroy Correct Questions', key: 'category_tot_question_correct' },
                { label: 'Categroy Attempted Questions', key: 'category_tot_question_attempted' },
                { label: 'Categroy First Attempt Time Taken (In Seconds)', key: 'category_first_attempt_time_taken' },
                { label: 'Categroy Total Time Taken (In Seconds)', key: 'category_tot_time_taken' },
                { label: 'Categroy Average Correct Questions', key: 'category_avg_correct_question' },
                { label: 'Categroy Average Total Time Taken (In Seconds)', key: 'category_avg_total_time_taken' },
                { label: 'SubCategroy Name', key: 'subcategory_name' },
                { label: 'SubCategroy Start Time (In Seconds)', key: 'subcategory_start_time' },
                { label: 'SubCategory Completed Date', key: 'subcategory_completed_time' },
                { label: 'SubCategroy Correct Questions', key: 'subcategory_tot_question_correct' },
                { label: 'SubCategroy Attempted Questions', key: 'subcategory_tot_question_attempted' },
                { label: 'SubCategroy First Attempt Time Taken (In Seconds)', key: 'subcategory_first_attempt_time_taken' },
                { label: 'SubCategroy Total Time Taken (In Seconds)', key: 'subcategory_tot_time_taken' },
                { label: 'SubCategroy Average Correct Questions', key: 'subcategory_avg_correct_question' },
                { label: 'SubCategroy Average Total Time Taken (In Seconds)', key: 'subcategory_avg_total_time_taken' },
            ];

            console.log("headers", headers);
            let csvPerfData = this.state.perfData
            let currentTime = Moment.tz(Date(), this.appProperties.currentUserData.timeZone || "America/New_York");
            
            downloadCSV = (
                <div>
                    <CSVLink
                        data={csvPerfData}
                        headers={headers}
                        filename={'Performance Data' +
                            '_' +
                            currentTime.format() +
                            '.csv'
                        }
                    >
                        {
                        <Button style={{ marginTop: "15px" }} flat primary iconChildren="cloud_download" >Download CSV</Button>
                        }
                    </CSVLink>
                </div>
            );
        }
        return <SecureShow targetRole={1}>
            <Grid gutter={1} className="gradeBookPageContainer">
                { this.props.archiveMode ? 
                <Cell size={2} phoneSize={4} tabletSize={6}>
                    <label style={{paddingRight:"1em"}}>
                        {this.appProperties.schoolMode?"Academic Year: ":"Semester :"} </label>
                    <CustomDropDown 
                        placeholder={this.appProperties.schoolMode?"Select an Academic Year":"Select a Semester"}
                        id="semesterDropDown"
                        itemLabel="name"
                        itemValue="id"
                        loading={this.state.isSemesterLoading}
                        data={this.props.semesters}
                        onChange={this.onSemesterChange}
                        selectedValue={this.state.selectedSemesterID}
                    />
                </Cell>
                :
                null}
                {
                    this.state.showCourse ? null :

                        <Cell size={3} id="courseDropboxCell">

                            <label htmlFor="courseSelectBox">
                                {this.appProperties.schoolMode?'Standard':'Course'} </label>
                            {
                            <CourseDropDown
                                selectBoxID="courseSelectBox"
                                placeholder={this.appProperties.schoolMode?"Select Standard":"Select Course"}
                                fullWidth
                                courses={this.state.courses}
                                archiveMode={this.props.archiveMode}
                                itemLabel={this.state.archiveMode ? "label" : "title"}
                                onChange={this.onCourseChange}
                                loading={this.state.loadingCourse}
                                className="gradebook-dropdown" />}
                        </Cell>
                }

                {this.state.showSection === false || !(this.state.selectedCourseID > 0) ? null :
                    <Cell size={5} phoneSize={4} tabletSize={6} id='sectionSelectBoxCell'>
                        <label htmlFor="sectionSelectBox">Section </label>
                        <SectionDropDown
                            selectedCourseID={this.state.selectedCourseID}
                            selectBoxID="sectionSelectBox"
                            placeholder="Select   Section"
                            fullWidth
                            archiveMode={this.props.archiveMode}
                            sectionMap={this.state.sectionMap}
                            onChange={this.onSectionChange}
                            className=" gradebook-dropdown" 
                            selectAll={false}
                            perfDataMode={true}/>
                            
                    </Cell>
                }
                {
                    this.state.showCategoryButton  ? 
                    <React.Fragment>
                    <Cell size={5} phoneSize={4} tabletSize={6} id='sectionSelectBoxCell'>
                    <Button className="archive-button" primary raised onClick={this.showCategoryButtonOnClick}>Show Graded Categories</Button>
                    </Cell> 
                    <Cell size={5} phoneSize={4} tabletSize={6} id='sectionSelectBoxCell'>
                    <Button className="archive-button" primary raised onClick={this.showCategoryNonGradedButtonOnClick}>Show Non-Graded Categories</Button>
                    </Cell> 
                    </React.Fragment>
                    :null
                    
                }
                {this.state.showCategory === false  ? null :
                    <Cell size={12} phoneSize={4} tabletSize={6} id='categorySelectBoxCell'>
                        <CategoryDropDown
                            selectedCourseID={this.state.selectedCourseID}
                            selectedSectionID={this.state.selectedSectionIDsForCategory}
                            selectBoxID="categorySelectBox"
                            placeholder="Select Category"
                            fullWidth
                            archiveMode
                            loading={this.state.categoryLoading}
                            categoryMap={this.state.categoryMap}
                            graded = {true}
                            onChange={this.onCategoryChange}
                            className=" gradebook-dropdown" 
                            emptyData={this.categroyEmptyData}/>
                    </Cell>
                }
                {this.state.showNonGradedCategory === false  ? null :
                    <Cell size={12} phoneSize={4} tabletSize={6} id='categorySelectBoxCell'>
                        <CategoryDropDown
                            selectedCourseID={this.state.selectedCourseID}
                            selectedSectionID={this.state.selectedSectionIDsForCategory}
                            selectBoxID="categorySelectBox"
                            placeholder="Select Category"
                            fullWidth
                            archiveMode
                            graded = {false}
                            loading={this.state.categoryLoading}
                            categoryMap={this.state.categoryMap}
                            onChange={this.onNonGradedCategoryChange}
                            className=" gradebook-dropdown" 
                            emptyData={this.categroyEmptyData}/>
                    </Cell>
                }
                <Cell size={5} phoneSize={4} tabletSize={6} id='sectionSelectBoxCell'>
                    {this.state.showFetchDataButton === false ? null :                    
                    <Button className="archive-button" primary raised onClick={this.fetchDataButtonOnClick}>Fetch Data</Button>
                    }
                    {this.state.showNonGradedFetchDataButton === false ? null :                    
                    <Button className="archive-button" primary raised onClick={this.fetchNonGradedDataButtonOnClick}>Fetch Data</Button>
                    }
                </Cell>
                <Cell size={5} phoneSize={4} tabletSize={6} id='sectionSelectBoxCell'>
                    {this.state.showCsvDownloadButton === false   ? null :
                    this.state.showCsvDownloadButtonLoader === true ?  <LoadingSpinner />:
                         downloadCSV 
                    }
                </Cell>

            </Grid>


        </SecureShow>
    }
}

const CustomDropDown =(props) =>{
    const dataFull = props.data;
    
    const onChange = (_, index) => {
        props.onChange(props.data[index],index);
    }
    const onChangeNative = (event) =>{
        event.stopPropagation();
        if (event.target.value === 'nil')
            return;
        props.onChange({user_name:event.target.value},-1);
        
    }
    
    if(props.loading){
        return <BeatLoader loading={true} color={loaderColor}/>
    }
    if(props.hidden){
        return null;
    }
    
    if (props.native)
    return <span   className='native-select-box'>
    <select class="minimal"
        onChange={onChangeNative}
        value={props.selectedValue}
    >
     {
         [<option key='default' value='nil'>Select a Student</option>,
         dataFull.map(student=>{
             return <option key={student.user_name} value={student.user_name}>{student.student_name}</option>
         })]
     }   
</select></span>
    return <SelectField
                id={props.id}
                itemLabel={props.itemLabel}
                itemValue={props.itemValue}
                placeholder={props.placeholder}
                menuItems={dataFull !== undefined && dataFull !== null ? dataFull.slice(0,30) : []}
                onChange={onChange}
                value={props.selectedValue}
            />
}
